import { useTranslation } from "react-i18next";
import useVocation from "src/hooks/data/useVocation";
import { useCurrentUser } from "src/SessionBoundary";
import { DOMAIN_URL } from "src/shared/constants/constants";
import buildRegistrationUrl from "src/shared/utils/buildRegistrationUrl";
import { isCdl, resolveVocationId } from "src/types/Vocation";

export type ReferralLink = {
  /** Absolute registration URL carrying the student's invitation code. */
  referralLink: string;
  /** Vocation-aware message that accompanies the link when shared. */
  shareText: string;
  /** Short vocation name used in the share copy ("CDL", "Diesel Tech"). */
  vocationName: string;
};

/**
 * The current student's referral link and share copy. Shared by the Refer page
 * card and the post-exam referral onboarding so both surfaces send the same
 * message.
 */
export default function useReferralLink(referralCode: string): ReferralLink {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const vocationId = resolveVocationId(user.vocationId);
  const { data: vocation } = useVocation(vocationId);

  const referralLink = `${DOMAIN_URL}${buildRegistrationUrl({
    invitationCode: referralCode,
  })}`;
  const vocationName =
    vocation?.shortName ??
    (isCdl(vocationId) ? t("CDL") : t("the skilled trades"));
  const shareText = t(
    "Emerge Career helps people build careers in {{vocation}}. If you're ready for a fresh start, use my invitation to apply.",
    { vocation: vocationName }
  );

  return { referralLink, shareText, vocationName };
}
